import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import { setLevelTiers } from "../../Redux/TiersSlice";
import TiersService from "../../Services/http/TiersService";

export const getLevelTiers = async (dispatch) => {
  dispatch(setIsActiveSpinner(true));
  const response = await TiersService.getLeveTiers();
  dispatch(setIsActiveSpinner(false));
  if (response && response["message"] === "success") {
    dispatch(setLevelTiers(response));
  }
};
export const updateLevelTiersInDB = async (dispatch, levelTier) => {
  dispatch(setIsActiveSpinner(true));
  const response = await TiersService.updateLevelTiersTable(
    levelTier
  );
  dispatch(setIsActiveSpinner(false));
  if (!response || response["message"] !== "success") {
    alert(response["message"]);
  }
  getLevelTiers(dispatch);
};
